import "./Footer.css"

const Footer = ({ language }) => {
  const footerText = {
    en: {
      continuity: "Abba go again",
      copyright: "© 2025 Kano State Government. All rights reserved.",
      governor: "",
    },
    ha: {
      continuity: "4 + 4",
      copyright: "© 2025 Gwamnatin Jihar Kano. Duk haƙƙi an ajiye.",
      governor: "",
    },
  }

  const content = footerText[language]

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <p className="continuity">{content.continuity}</p>
          <p className="governor">{content.governor}</p>
        </div>
        <div className="footer-bottom">
          <p>{content.copyright}</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
